// extracted by mini-css-extract-plugin
module.exports = {"how-to-update-price":"HowToUpdatePrice_how-to-update-price__191MQ","title":"HowToUpdatePrice_title__3YhV0","toggles":"HowToUpdatePrice_toggles__1zAp2"};